/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a heatmap from a data matrix — visualise magnitude with colour, no sign-up.`)
};

const es_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un mapa de calor a partir de una matriz de datos — visualiza la magnitud con color, sin registro.`)
};

const de_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie eine Heatmap aus einer Datenmatrix — visualisieren Sie Größenordnungen mit Farbe, keine Anmeldung erforderlich.`)
};

const nl_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een heatmap van een datamatrix — visualiseer grootte met kleur, geen registratie nodig.`)
};

const fr_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une carte de chaleur à partir d'une matrice de données — visualisez l'ampleur par la couleur, sans inscription.`)
};

const it_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una mappa di calore da una matrice di dati — visualizza la grandezza con il colore, senza registrazione.`)
};

const pt_br2_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um mapa de calor a partir de uma matriz de dados — visualize a magnitude com cores, sem cadastro.`)
};

const pt_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um mapa de calor a partir de uma matriz de dados — visualize a magnitude através da cor, sem registo.`)
};

const ja_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データ行列からヒートマップを作成します — 色で大きさを可視化、登録不要。`)
};

const zh_heat_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据数据矩阵创建热力图——用颜色可视化数值大小，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_tool_description", locale)
	if (locale === "en") return en_heat_tool_description(inputs)
	if (locale === "es") return es_heat_tool_description(inputs)
	if (locale === "de") return de_heat_tool_description(inputs)
	if (locale === "nl") return nl_heat_tool_description(inputs)
	if (locale === "fr") return fr_heat_tool_description(inputs)
	if (locale === "it") return it_heat_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_heat_tool_description(inputs)
	if (locale === "pt") return pt_heat_tool_description(inputs)
	if (locale === "ja") return ja_heat_tool_description(inputs)
	return zh_heat_tool_description(inputs)
};